import {
  buildConventionalScopeBody,
  ConventionalScope,
  conventionalScopeKey,
  coreApi,
  BlueprintFamilyMonthlyTrendsItem,
  BlueprintFamilyTrendsWindowDays,
} from '../core'

// Response shape for POST /blueprint-families/trends/event-groups: the shared monthly
// batched-trends item, where `id` is the event-group id (e.g. "6476f657d53d5f00afcf9bf3"
// → "Monetization") rather than a blueprint id. The series is group-scoped — every game
// running any event of the group, so it reconciles with `distinctGamesCount` on the
// matching rollup row.
export type BlueprintFamilyEventGroupTrendsApiItem = BlueprintFamilyMonthlyTrendsItem

// Query args for the batched event-group trends request. `eventGroupIds` accepts 1–10 ids;
// the BE keys each response item by the event-group id passed here.
// `conventionalSubgenreIds` is an optional body list scoping the adoption denominator.
type GetBlueprintFamilyEventGroupTrendsQueryParams = {
  eventGroupIds: string[]
  windowDays?: BlueprintFamilyTrendsWindowDays
} & ConventionalScope

const eventGroupTrendsApi = coreApi.injectEndpoints({
  endpoints: (builder) => ({
    getBlueprintFamilyEventGroupTrends: builder.query<BlueprintFamilyEventGroupTrendsApiItem[], GetBlueprintFamilyEventGroupTrendsQueryParams>({
      // POST-with-body modeled as a query (read-only fan-out), mirroring `getEstimatesList`.
      query: ({ eventGroupIds, windowDays, ...scope }) => ({
        url: 'blueprint-families/trends/event-groups',
        method: 'POST',
        params: {
          ...(windowDays !== undefined ? { windowDays } : {}),
        },
        body: { eventGroupIds, ...buildConventionalScopeBody(scope) },
      }),
      // Reuse the shared blueprint cache tag; encode the request shape so distinct
      // id-sets / windows / scopes cache independently.
      providesTags: (_result, _err, { eventGroupIds, windowDays, ...scope }) => [
        {
          type: 'BlueprintFamilies',
          id: `trends/event-groups/${[...eventGroupIds].sort().join(',')}/${windowDays ?? 'default'}/${conventionalScopeKey(scope)}`,
        },
      ],
    }),
  }),
})

export const { useGetBlueprintFamilyEventGroupTrendsQuery } = eventGroupTrendsApi
